// This icon file is generated automatically.
var PGoldOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M3.34 5.38H8.71a.12.12 0 00.1-.15l-.63-3.88c0-.06-.06-.1-.12-.1H3.97a.12.12 0 00-.12.1l-.63 3.88v.02c0 .07.06.13.12.13zM4.77 2.3h2.5l.31 2H4.44l.33-2zm.04 4.42c-.01-.06-.06-.1-.13-.1H.6a.12.12 0 00-.13.1l-.62 3.87v.03c0 .06.05.12.12.12H5.33a.12.12 0 00.1-.15l-.62-3.87zM1.07 9.69l.32-2h2.5l.32 2H1.07zm11.08.91l-.62-3.87c-.01-.06-.07-.1-.13-.1H7.32a.12.12 0 00-.13.1l-.63 3.87v.03c0 .06.06.12.13.12H12.05a.13.13 0 00.1-.15zM7.8 9.7l.32-2h2.5l.32 2H7.79z", "fill-rule": "nonzero" } }] }, "name": "p-gold", "theme": "outlined" };
export default PGoldOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PGoldOutlined.js
// module id = 3447
// module chunks = 0